"use client";
import {FaHeart, FaRegHeart} from "react-icons/fa";
import useAxiosAuth from "@/lib/hooks/useAxiosAuth";
import {useRouter} from "next/navigation";
import toast from "react-hot-toast";

export default function LikeButton({type, idType, isLiked = false, minify = false, numberLike = 0}){
    const axios = useAxiosAuth();
    const router = useRouter();

    function setLiked(){
        let currentUrl = 'likes';
        if(type === "posts"){
            currentUrl += `/post/${idType}`;
        }

        if(type === "comments"){
            currentUrl += `/comment/${idType}`;
        }

        axios.post(currentUrl)
            .catch(() => toast.error('Une erreur est survenue'))
            .finally(() => router.refresh());
    }

    if(minify){
        return (
            <button className={`hover:underline ${isLiked ? 'text-primary font-semibold flex items-center gap-x-1 fill-primary' : ''}`} onClick={setLiked}>
                {isLiked &&(
                    <FaHeart/>
                )}
                J&apos;aime {numberLike > 0 ? '(' + numberLike + ')' : ""}
            </button>
        )
    } else {
        return (
            <button className={`flex items-center gap-x-2 hover:bg-gray-100 px-4 py-1 ${isLiked ? 'text-primary fill-primary font-semibold' : ''}`} onClick={setLiked}>
                {isLiked
                    ?
                    <FaHeart size={18}/>
                    :
                    <FaRegHeart size={18}/>
                }

                J&apos;aime
            </button>
        )
    }

}